module.exports = __webpack_public_path__ + "static/media/f7.56df6b99.jpg";